export default "__VITE_ASSET__e584a614__"